import download from "./download";
import axios from 'axios'

async function downloadInProgressTransactionsExcelSummary() {
  const token = localStorage.getItem('token')

  try {
    const url = `${process.env.REACT_APP_API_URL}/admin/download/in-progress/summary/excel`;
    
    axios({
      url: url,
      method: "GET",
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response: any) => {
      download(
          response.data,
          `In Progress Transactions Summary`,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        );
    })
  } catch (error) {
    console.error("File missing")
  }
}

export default downloadInProgressTransactionsExcelSummary;